import { type ComponentType } from 'react';

import { formControlLabelClasses } from '@liquidweb-dev/undercurrent/FormControlLabel';
import IconButton from '@liquidweb-dev/undercurrent/IconButton';
import InfoIcon from '@liquidweb-dev/undercurrent/icons/lucide/Info';
import RadioTile, {
	RadioTileProps,
} from '@liquidweb-dev/undercurrent/RadioTile';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Tooltip from '@liquidweb-dev/undercurrent/Tooltip';
import { LucideSvgProps } from '@liquidweb-dev/undercurrent/types/svgTypes';

export interface MethodTileProps extends Omit<RadioTileProps, 'sx'> {
	Icon: ComponentType<LucideSvgProps>;
	tooltipMessage: string;
}

const MethodTile = ({
	Icon,
	children,
	tooltipMessage,
	...rest
}: MethodTileProps) => (
	<RadioTile
		sx={{
			flex: 1,
			width: '100%',
			[`& .${formControlLabelClasses.label}`]: {
				width: '100%',
			},
		}}
		{...rest}
	>
		<Stack
			sx={{
				flexDirection: 'row',
				alignItems: 'center',
				gap: 200,
				justifyContent: 'space-between',
				width: '100%',
			}}
		>
			<Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 100 }}>
				<Icon
					sx={({ size }) => ({
						height: size.sm,
						width: size.sm,
					})}
				/>
				<span>{children}</span>
			</Stack>
			<Tooltip
				variant="fancy"
				title="What is this?"
				message={tooltipMessage}
				arrow
			>
				<IconButton size="small" variant="barebones">
					<InfoIcon sx={({ vars }) => ({ color: vars.palette.uc.icon.weak })} />
				</IconButton>
			</Tooltip>
		</Stack>
	</RadioTile>
);

export default MethodTile;
